"use client";

import { useEffect, useRef, useState } from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function IntoTheShadow() {
  const videoRef = useRef<HTMLDivElement | null>(null);
  const [offsetY, setOffsetY] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      setOffsetY(scrollY * 0.5);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section data-section-id="4840" id="into-the-shadow" className="relative bg-background text-foreground min-h-screen w-full overflow-hidden">
      {}
      <div ref={videoRef} className="absolute inset-0 w-full h-[120%] will-change-transform" style={{
      transform: `translateY(${offsetY}px)`
    }}>
        <video className="w-full h-full object-cover" autoPlay loop muted playsInline poster="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693015/img/eclipse_concert_poster_hq.png" style={{
        filter: "saturate(1.2) contrast(1.1) brightness(0.8)"
      }}>
          <source src="/img/eclipse_tour_motion.mp4" type="video/mp4" />
        </video>
        {}
        <div className="absolute inset-0 opacity-[0.05] pointer-events-none mix-blend-overlay" style={{
        backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")"
      }} />
      </div>

      {}
      <div className="absolute inset-0 pointer-events-none" style={{
      background: "linear-gradient(to top, hsl(240, 30%, 2%) 0%, hsla(240, 30%, 2%, 0.7) 30%, hsla(240, 30%, 2%, 0.4) 55%, hsla(240, 30%, 2%, 0.1) 75%, hsla(240, 30%, 2%, 0) 100%)"
    }} />

      {}
      <div className="hidden md:flex absolute top-32 right-8 lg:right-12 z-10 items-center">
        <span className="font-mono text-[11px] tracking-[0.3em] uppercase text-muted-foreground" style={{
        writingMode: "vertical-rl",
        transform: "rotate(180deg)"
      }}>
          LAT: 40.7128 / LON: 74.0060
        </span>
      </div>

      {}
      <div className="hidden md:flex absolute bottom-12 right-12 z-10 flex-col items-center gap-4">
        <span className="font-mono text-[11px] tracking-[0.3em] uppercase text-primary" style={{
        writingMode: "vertical-rl"
      }}>
          Pulse
        </span>
        <div className="relative h-[60px] w-px overflow-hidden bg-border">
          <div className="absolute top-0 left-0 w-px h-full bg-primary animate-[scrollLine_2s_ease-in-out_infinite]" />
        </div>
      </div>

      {}
      <div className="relative z-10 min-h-screen flex flex-col justify-end px-6 sm:px-12 md:px-16 lg:px-24 pb-20 sm:pb-24 lg:pb-32 pt-32">
        <div className="max-w-full md:max-w-[55%] mx-auto md:mx-0 text-center md:text-left">
          {}
          <div className="flex justify-center md:justify-start mb-6">
            <div className="h-px w-[60px] bg-primary" />
          </div>

          {}
          <p className="font-mono text-[11px] sm:text-[12px] tracking-[0.3em] uppercase text-primary mb-8 sm:mb-10">
            THE ECLIPSE — WORLD TOUR 2024
          </p>

          {}
          <h1 className="font-default font-extrabold text-foreground leading-[0.9] mb-8 sm:mb-10 tracking-tighter" style={{
          fontSize: "clamp(3.5rem, 9vw, 9.75rem)"
        }}>
            Into the <em className="italic font-light text-primary">Shadow</em>
          </h1>

          {}
          <p className="font-default text-base sm:text-[17px] leading-relaxed text-muted-foreground max-w-2xl mx-auto md:mx-0 mb-16">
            Experience the celestial-noir pop phenomenon. A journey through deep midnight soundscapes and electric magenta light.
          </p>

          {}
          <div className="flex flex-col sm:flex-row items-center gap-6 sm:gap-10">
            <Button asChild variant="default" size="lg" className="bg-primary text-primary-foreground shadow-lg shadow-primary/40 hover:translate-x-1 transition-transform duration-300 rounded-md font-mono text-xs tracking-[0.25em] uppercase px-8 h-12">
              <Link to="/EclipsePage">Download EPK</Link>
            </Button>

            <Link to="#" className="group inline-flex items-center gap-2 font-mono text-xs tracking-[0.25em] uppercase text-foreground">
              <span className="relative pb-1">
                View Tour Dates
                <span className="absolute bottom-0 left-0 h-px w-0 bg-primary transition-all duration-500 group-hover:w-full" />
              </span>
              <ArrowRight className="size-3.5 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes scrollLine {
          0% { transform: translateY(-100%); }
          100% { transform: translateY(100%); }
        }
      `}</style>
    </section>;
}